import CommentThread from 'components/comments/CommentThread';
import useCommentThread from 'components/comments/useCommentThread';
import { TaskCommentsSkeleton } from 'components/tasks/panel/TaskPanelSkeletons';
import ApiDatabase from 'server';

// The legacy api answers through callbacks.
const request = (call, payload) => new Promise((resolve, reject) => call(payload, resolve, reject));

// A comment of the api in the shape of a task's comment. Its author deletes it;
// nobody edits it, the api has no route for that.
const toThreadComment = (comment, meId) => ({
  id: comment._id,
  body: comment.comment,
  author: comment.employee,
  createdAt: comment.createdAt,
  canDelete: Boolean(meId) && comment.employee?._id === meId,
});

/**
 * The comments of a temp worker, as those of a task: the panel draws the
 * thread in its body and the CommentComposer under it (`belowBody`), with
 * `thread.send`. Loaded while `enabled` (its tab is open). No mention: the api
 * does not notify anybody.
 */
export const useTempWorkerComments = ({ idUser, meId, enabled }) =>
  useCommentThread({
    key: enabled && idUser && meId ? `${idUser}:${meId}` : null,
    load: () =>
      request(ApiDatabase.getCommentsByTempWorker, { idUser }).then((list) =>
        (list ?? []).map((comment) => toThreadComment(comment, meId)),
      ),
    add: (body) => request(ApiDatabase.postCommentTempWorker, { idUser, comment: body }).then((saved) => toThreadComment(saved, meId)),
    remove: (idComment) => request(ApiDatabase.deleteCommentTempWorker, { idComment }),
  });

const CommentTempWorker = ({ thread, meId }) =>
  thread.comments ? (
    <CommentThread comments={thread.comments} people={[]} meId={meId} onDelete={thread.removeComment} pendingIds={thread.pendingIds} />
  ) : (
    <TaskCommentsSkeleton />
  );

export default CommentTempWorker;
